import { Chip, Link, Typography } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

import {
  assignmentLabel,
  formatWhen,
  needsAgentAttention,
  stateTone,
  ticketStateLabel,
  Ticket
} from '../../helpers/ticketWorkflow'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import useStyles from './styles/SupportQueueTable.styles'

interface SupportQueueRowProps {
  ticket: Ticket
}

export default function SupportQueueRow({ ticket }: SupportQueueRowProps) {
  const classes = useStyles()
  const needsAttention = needsAgentAttention(ticket)

  return (
    <div
      className={clsx(classes.tableRow, {
        [classes.needsAttentionRow]: needsAttention
      })}>
      <div>
        <Link
          component={LocalizedLink}
          to={`/support/tickets/detail/${ticket.id}`}>
          <bdi dir="ltr">{ticket.ticketNumber}</bdi>
        </Link>
      </div>
      <div>
        {/* <bdi> because the bidi algorithm reorders a mixed TYPE:CODE-123
            string in an RTL run, and a transposed identifier is wrong for an
            agent about to search it. */}
        {ticket.reporterEntityRef ? (
          <bdi dir="ltr">
            {`${ticket.reporterEntityRef.type}:${ticket.reporterEntityRef.code}`}
          </bdi>
        ) : (
          '—'
        )}
      </div>
      <div>
        <Typography variant="body1" className={classes.titleCell}>
          {ticket.title}
        </Typography>
      </div>
      <div>
        <Chip
          size="small"
          label={ticketStateLabel(ticket.state)}
          color={stateTone(ticket.state)}
        />
      </div>
      <div>
        {/* The row tint says the same thing, but colour alone is not a signal
            an agent can rely on — this chip is what carries the meaning. */}
        {needsAttention && (
          <Chip
            size="small"
            color="secondary"
            label={getTranslate('Needs Adotel')}
          />
        )}
        {/* Bare <bdi>, deliberately not the portal's usual <bdi dir="ltr">:
            assignmentLabel returns EITHER a Latin id OR a translated Farsi
            phrase, so a forced direction is wrong for one of them. dir="auto"
            infers from the first strong character and is right for both.
            Without it, the truncation ellipsis — a bidi-neutral character —
            resolves to the paragraph direction in Farsi and lands on the
            visual LEFT, reading as though the START of the id was elided.

            No `title` here. It was a mouse-only affordance: this renders a <p>,
            which is not focusable, and `title` does not fire on touch. The full
            id lives on the ticket detail screen, where it is selectable. */}
        <Typography variant="body1" component="span">
          <bdi>{assignmentLabel(ticket)}</bdi>
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{formatWhen(ticket.changedAt)}</Typography>
      </div>
      <div />
    </div>
  )
}
